import styles from './AsideElementLearnMessage.module.scss';

function AsideElementLearnMessage({ tutorial, message }) {

  if (!tutorial || tutorial === "null") {
    return null;
  }

  return (<>
  <div>Tutorial warnings</div>
    <div className={styles["main"]}>
      {message}
    </div>
  </>
  )
}

export default AsideElementLearnMessage;